export default "__VITE_ASSET__DczTLwTx__"